<template>
  <div v-if="!isLogged" class="login" @click="onLogin">
    <a
      :title="loginText"
      data-google-interstitial="false"
    >
      <i class="fa fa-user-circle"></i>
      <span>{{ loginText }}</span>
    </a>
  </div>

  <div v-else class="login-container" :class="{ 'improve-account': userType === 2 }">
    <div class="login-user">
      <div class="user" :class="{ 'user-nopartner' : isPartner }" @click="onClick">
        <edi-menu
          :urls="urls"
          :nick="userNick"
          :showMenu="showMenu"
          :menuClass="menuClass"
        />
        <img
          v-if="userAvatarUrl !== '/assets/img/default-user-avatar.png'"
          class="user-photo"
          :src="userAvatarUrl"
          :alt="userNick"
        />
        <span v-else>
          <i class="fa fa-user-circle"></i>
        </span>
      </div>
    </div>

    <div v-if="userType === 2" class="perfil-quota">
      <a :href="increaseQuotaUrl">Aumenta tu cuota</a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import EdiMenu from './EdiMenu';

export default {
  name: 'edi-login',
  components: {
    EdiMenu
  },
  props: {
    urls: Array,
    loginText: String,
    menuClass: String
  },
  data() {
    return {
      showMenu: false
    }
  },
  computed: {
    ...mapGetters([
      'loginUrl',
      'redirectUrl',
      'increaseQuotaUrl',
      'userType',
      'isLogged',
      'isPartner',
      'userNick',
      'userAvatarUrl'
    ])
  },
  methods: {
    onLogin() {
      window.dataLayer.push({
        event: 'click_login',
        eventData: {
          im_location: 'header'
        }
      });
      fetch(`${this.redirectUrl}?op=saveref`, {method: 'GET'})
        .then(res => {
          // aquí deberíamos comprobar si res.status !== 200 o !res.ok para
          // validar el estado de la respuesta, pero el servicio de api
          // de callback devuelve siempre 404, así que no comprobamos nada.
          window.location.href = this.loginUrl + "?imLocation=perfil_usuario";
        })
        .catch(err => {
          // sólo si err.status === 50x
          console.log(err);
        });
    },
    onLogout() {
      // TODO:
      //  implementar el método onLogout cuando se clicke
      //  sobre el item del menú `Cerrar sesión` esto aún
      //  desarrollado pues se está modificando el marcado
      //  del header en esta tarea: https://mgr.bitban.com/issues/68512
      this.onLogin();
    },
    onClick() {
      this.showMenu = !this.showMenu;
    }
  },
}
</script>
